module.exports = __webpack_public_path__ + "static/media/YF103_1.8b836125.jpg";